module.exports = __webpack_public_path__ + "img/close.48c70754.svg";